export default __webpack_public_path__ + "static/media/card_dexpro4.ca70cfe8.png";